import React, { useEffect } from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { JournalistFrapiData } from '../../../../core/features/author-bio/types.js';
import type { FrapiTeaserItem } from '../../../types/frapi-types.js';

import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import {
  trackAuthorBioPageView,
  withByfunnPulse,
} from '../../../pulse/index.js';
import { AuthorResults } from './AuthorResults.js';
import Footer from '../../components/commonComponents/Footer.js';
import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import AuthorInfo from './AuthorInfo.js';
import BackButton from '../../../../core/react/components/BackButton.js';
import { ListsProvider } from '../../components/saving/ListsProvider.js';

export type BioPageProps = {
  data: JournalistFrapiData<FrapiTeaserItem>;
  options: OptionsFromRequest;
};

const AuthorBioPage: React.FC<BioPageProps> = ({ data, options }) => {
  const { siteVersion, currentUrl, isHermesApp } = options;
  const { author, authorContent } = data;
  const { trackViewListing, registerViewElementTracking } = usePulseContext();

  useEffect(() => {
    if (author.slug) {
      trackAuthorBioPageView(trackViewListing, currentUrl, author.slug);
    }

    registerViewElementTracking();
  }, [
    author.slug,
    currentUrl,
    data.author.slug,
    registerViewElementTracking,
    trackViewListing,
  ]);

  const isMobile = siteVersion === 'phone';

  return (
    <ListsProvider>
      <div className={`${siteVersion}-front`}>
        <div className="author-bio-page">
          <Navigation fullWidth={!isMobile} isHermesApp={isHermesApp} />
          <BackButton pulseId="authorbio:previous-page">
            <span className="icon"></span>
            <span className="label">tilbake</span>
          </BackButton>
          <AuthorInfo author={author} isMobile={isMobile} />
          <AuthorResults
            currentPage={options.page ? parseInt(options.page) : 1}
            collection={authorContent.articles}
            resultsCount={authorContent.resultsCount}
            isMobile={isMobile}
            slug={data.author.slug || ''}
          />
        </div>
        <Footer isMobile={isMobile} />
      </div>
    </ListsProvider>
  );
};

const AuthorBioWithPulse = withByfunnPulse(AuthorBioPage);

export { AuthorBioWithPulse as AuthorBioPage };
